module.exports = __webpack_public_path__ + "static/media/doodle.36d89dcf.jpg";